import { render, staticRenderFns } from "./wei-tuo-he-tong.vue?vue&type=template&id=6a88f6f4&scoped=true&"
import script from "./wei-tuo-he-tong.vue?vue&type=script&lang=js&"
export * from "./wei-tuo-he-tong.vue?vue&type=script&lang=js&"
import style0 from "./wei-tuo-he-tong.vue?vue&type=style&index=0&id=6a88f6f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a88f6f4",
  null
  
)

export default component.exports